<div class="card">
  <div class="card-header">
    <h3>{{ "CALCULATE_COST" | translate }}</h3>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-12 form-group">
        <label for="type">{{ "TYPE" | translate }}: </label>
        <ng-select id="type" [(ngModel)]="selectedType">
          <ng-option value="indeterminate">{{ "INDETERMINATE" | translate }}</ng-option>
          <ng-option value="apprenticeship">{{ "APPRENTICESHIP" | translate }}</ng-option>
        </ng-select>
      </div>
      <div class="col-12 form-group">
        <label for="salary_yearly_gross">{{ "BONUS" | translate }}: </label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input class="form-control" id="bonus" type="text" [(ngModel)]="bonus" (change)="formatMoney('bonus')" />
        </div>
      </div>
      <div class="col-12 form-group">
        <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}: </label>
        <div class="input-group input-group-merge">
          <div class="input-group-prepend">
            <span class="input-group-text">&euro;</span>
          </div>
          <input class="form-control" id="salary_yearly_gross" type="text" [(ngModel)]="ral" (change)="formatMoney('ral')" />
        </div>
      </div>
      <div class="col-lg-1 col-12 d-flex align-items-center mt-075">
        <button class="btn btn-primary" (click)="calculateCost()" [disabled]="!ral || ral === '0,00' || !selectedType">{{ "CALCULATE" | translate }}</button>
        <button class="btn btn-secondary ml-2" (click)="reset()" [disabled]="!calculatedContract">{{ "RESET" | translate }}</button>
      </div>
    </div>
    <div class="row mt-3" *ngIf="calculatedContract">
      <div class="col-12">
        <h2>
          {{ "COST_GENERATED_CONTRACT" | translate }}
        </h2>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "LEVEL" | translate }}:</div>
        <div>{{ calculatedContract.level }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "SALARY_YEARLY_GROSS" | translate }}:</div>
        <div>{{ calculatedContract.salary_yearly_gross | currency: 'EUR'}}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "TOTAL_YEARLY" | translate }}:</div>
        <div>{{ calculatedContract.total_yearly | currency: 'EUR' }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "TOTAL_MONTH" | translate }}:</div>
        <div>{{ calculatedContract.total_month | currency: 'EUR' }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "NET_MONTHLY_12" | translate }}:</div>
        <div>{{ calculatedContract.net_monthly_12 | currency: 'EUR' }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "NET_MONTHLY_13" | translate }}:</div>
        <div>{{ calculatedContract.net_monthly_13 | currency: 'EUR' }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "TOTAL_SALARY_MONTH_13" | translate }}:</div>
        <div>{{ calculatedContract.total_net_monthly_13 | currency: 'EUR' }}</div>
      </div>
      <div class="form-group col-12">
        <div class="font-weight-bold">{{ "BONUS" | translate }}:</div>
        <div>{{ calculatedContract.bonus | currency: 'EUR' }}</div>
      </div>
      <div class="col-12">
        <div class="font-weight-bold">{{ "TOTAL_DAILY" | translate }}:</div>
        <div>{{ calculatedContract.total_daily | currency: 'EUR' }}</div>
      </div>
    </div>
  </div>
</div>
